import React, { useRef } from "react";

import MenuIcon from "@mui/icons-material/Menu";
import { Stack, Toolbar } from "@mui/material";
import { Menu } from "components/popups";
import { HighchartsReactRefObject } from "highcharts-react-official";
import { useReportsQueriesSelector } from "store";
import { DealGraph as DealGraphType } from "store/types";

import { GroupByMenu } from "..";
import { DealGraphConfContent } from "../Deal-graph-conf-content/DealGraphConfContent";
import { MeasureGraph } from "../Measure-Graph/MeasureGraph";

import "./DealGraph.styles.scss";

interface DealGraphProps {
  loading: boolean;
  graphData?: DealGraphType;
}

export const DealGraph: React.FC<DealGraphProps> = React.memo(({ loading, graphData }) => {
  const { interval } = useReportsQueriesSelector();
  const chartRef = useRef<HighchartsReactRefObject>(null);

  const handleExport = (type: string) => {
    (chartRef.current?.chart as any)?.exportChartLocal({ type });
  };

  return (
    <div className="line-graph" style={{ position: "relative" }}>
      <Toolbar sx={{ paddingX: "25px", display: "flex", justifyContent: "space-between" }}>
        <span className="title">{graphData?.title || ""}</span>
      </Toolbar>
      <MeasureGraph loading={loading} graphData={graphData} interval={interval} chartRef={chartRef} />
      <Stack
        className="menu-trigger-blocks chart-option"
        sx={{
          position: "absolute",
          top: "10px",
          right: "10px",
          flexDirection: "row",
          gap: 1,
          zIndex: 1000
        }}
      >
        <GroupByMenu>
          <DealGraphConfContent />
        </GroupByMenu>
        <Menu
          keepTriggerEnabled
          icon={<MenuIcon />}
          options={[
            {
              title: "View in full screen",
              onClick: () => (chartRef.current?.chart as any).fullscreen.toggle()
            },
            {
              title: "Print chart",
              onClick: () => (chartRef.current?.chart as any).print(),
              hasLine: true
            },
            {
              title: "Download PNG image",
              onClick: () => handleExport("image/png")
            },
            {
              title: "Download JPEG image",
              onClick: () => handleExport("image/jpeg")
            },
            {
              title: "Download PDF Document",
              onClick: () => handleExport("application/pdf")
            },
            {
              title: "Download SVG vector image",
              onClick: () => handleExport("image/svg+xml"),
              hasLine: true
            },
            {
              title: "Download CSV",
              onClick: () => (chartRef.current?.chart as any).downloadCSV()
            },
            {
              title: "Download XLS",
              onClick: () => (chartRef.current?.chart as any).downloadXLS()
            }
          ]}
        />
      </Stack>
    </div>
  );
});
